module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Compiling-0f03450fb1108f8638a8848d5c9b51ba.svg";